import React from 'react';
import { useTheme } from '@mui/material';
import { useTimeline } from '@features/purchasing/hooks/useTimeline';

interface CurrentDateIndicatorProps {
    weekWidth?: number;
    headerColumnWidth?: number;
}

const CurrentDateIndicator: React.FC<CurrentDateIndicatorProps> = ({
    weekWidth = 200,
    headerColumnWidth = 300
}) => {
    const theme = useTheme();
    const { getPositionsForDate } = useTimeline({
        weekWidth,
        headerColumnWidth
    });

    return (
        <div style={{
            position: 'absolute',
            top: 0,
            left: `${getPositionsForDate(new Date())}px`,
            height: '100%',
            width: 1,
            backgroundColor: theme.palette.primary.main,
        }}>
        </div>
    );
};

export default CurrentDateIndicator;
